import React from "react";
import "../css/CustomerCount.css";

export default function CustomerCount({ count = 57 }) {
  const people = [
    ["F", "avatar--one"],
    ["R", "avatar--two"],
    ["E", "avatar--three"],
    ["S", "avatar--four"],
    ["H", "avatar--five"],
  ];
  return (
    <section
      className="customer-proof"
      aria-label="FreshLoop customer community"
    >
      <div className="proof-leaves proof-leaves--left" aria-hidden="true">
        ✦
      </div>
      <div className="proof-people" aria-hidden="true">
        {people.map(([initial, cls]) => (
          <div className={`avatar ${cls}`} key={cls}>
            {initial}
          </div>
        ))}
        <span className="avatar-more">
          +{Math.max(0, count - people.length)}
        </span>
      </div>
      <div className="proof-copy">
        <p className="proof-eyebrow">JOINED BY</p>
        <h2>
          <span className="customer-count">{count}</span> customers
        </h2>
        <p className="proof-subtitle">
          Real people. Fresh choices. A healthier community.
        </p>
      </div>
      <div className="proof-thanks">
        <span className="thanks-spark" aria-hidden="true">
          〰
        </span>
        <p>
          Thank you
          <br />
          for being part
          <br />
          of FreshLoop!
        </p>
        <span className="thanks-heart" aria-hidden="true">
          ♡
        </span>
      </div>
      <div className="proof-leaves proof-leaves--right" aria-hidden="true">
        ✦
      </div>
    </section>
  );
}
